import { FullValidationErrorFragment } from '@common/graphql/fragments';
import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ClearWorkloadMutationCgResponse,
  ClearWorkloadMutationVariables,
  UpsertWorkloadMutationCgResponse,
  UpsertWorkloadMutationVariables,
} from '@common/graphql/schema';

export const UPSERT_WORKLOAD_MUTATION: TypedDocumentNode<
  UpsertWorkloadMutationCgResponse,
  UpsertWorkloadMutationVariables
> = gql`
  mutation UpsertWorkload(
    $organizationUnitId: ID!
    $roleId: ID!
    $blocks: [WorkloadBlockInput!]!
    $shiftGapIdsToCancel: [ID!]
  ) {
    upsertWorkload(
      organizationUnitId: $organizationUnitId
      roleId: $roleId
      blocks: $blocks
      shiftGapIdsToCancel: $shiftGapIdsToCancel
    ) {
      blocks {
        id
        startsAt
        endsAt
        headcount
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export const CLEAR_WORKLOAD_MUTATION: TypedDocumentNode<
  ClearWorkloadMutationCgResponse,
  ClearWorkloadMutationVariables
> = gql`
  mutation ClearWorkload(
    $organizationUnitId: ID!
    $roleId: ID!
    $startsAt: ISO8601DateTime!
    $endsAt: ISO8601DateTime!
  ) {
    clearWorkload(
      organizationUnitId: $organizationUnitId
      roleId: $roleId
      startsAt: $startsAt
      endsAt: $endsAt
    ) {
      success
    }
  }
`;
